/* istanbul ignore file */
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment';
import { toast } from 'react-toastify';
import { translate } from 'containers/services/translate';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import currentUserStorage from 'containers/services/security/current-user-storage';
import SahamDialog from 'components/SahamDialog';

export interface ValidationDialogProps {
  intl: IntlShape;
  claimId: number;
  claimNumber: string;
  open: boolean;
  handleClose: any;
  judiciaryProcessId: any;
  supportDocument: any;
  requestMakeDecisionSupportDocument?: Function;
  status: string;
  claim: any;
  procedureType: string;
}

export const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  const handleValidate = () => {
    const { ...rest } = props.supportDocument;
    if (props.status && props.requestMakeDecisionSupportDocument) {
      props.requestMakeDecisionSupportDocument(
        {
          ...rest,
          supportDocumentId: rest.id,
          status: props.status,
          procedureType: props.procedureType,
          decidedBy: currentUserStorage.get().username,
          decidedAt: moment().format(),
          claimId: props.claimId,
          judiciaryProcessId: props.judiciaryProcessId,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
        },
        successCallBackDecision,
      );
    }
  };

  const successCallBackDecision = () => {
    toast.success(translate(messages.validationToastSuccess, props));
    props.handleClose();
  };
  return (
    <SahamDialog
      handleValidate={handleValidate}
      handleClose={props.handleClose}
      title={translate(messages.courtManagerConfirmationDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerConfirmationDialogCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerConfirmationDialogConfirm,
        props,
      )}
      open={props.open}
    >
      {translate(messages.courtManagerConfirmationDialogContent, props)}
    </SahamDialog>
  );
};

export default injectIntl(ValidationDialog);
